import { Fragment } from 'react';
import { styled } from '@mui/material/styles';

export default function LogoOnlyLayout(props) {
  const { children } = props;
  return <>{children}</>;
}
